/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-01-26 15:37:18
 * @FilePath: \baishu_react_ui\src\components\BsyDept\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React from 'react'
import './index.css'
import { BsyUtils } from '../../utils/Utils';
import BsyDeptGroup from '../BsyDeptGroup';

export default class BsySelectDeptGroup extends BsyDeptGroup {


  static defaultProps = {
    baseCls: "bsy-select-dept",
    width: 720,
    height: 80,
    value: [],
    onRelyLimit: null,
    type: 'deptgroup',
  }

  constructor(props) {
    super(props);

    this.value = this.getValueId(props.value)
    this.element = React.createRef();
    if (props.source == "BsyFormWidgetManager")
      this.current_departments()
  }


  renderBody = () => {
    const { value, islinkQuery, ftoken } = this.state;
    let hasValue = '';
    return <>
      <ul className="select-list"   >
        {

          !BsyUtils.isObjectEmpty(value) ? value.map(v => {
            let item = window.deptSelectMap[v]
            if (BsyUtils.isObjectEmpty(item)) {
              item = { id: value }
            }
            if (item)
              hasValue = true;
            return item ? <li className="select-item" id={v}>
              <i className="select-icon icon-department"></i>
              <span>{BsyUtils._toDeptUser(item)}</span>
            </li> : ''
          }) : <div className="select-empty"> </div>
        }
      </ul>
      {
        this.renderBtn('icon-widget-deptgroup', hasValue)
      }

    </>
  }

  render() {
    const { cssName, css } = this.options
    if (!this.isEnabled()) {
      return this.renderDisablePane()
    }
    return (
      <div className={cssName} style={css}
        ref={this.element}
        onClick={this.onClick}
      >
        {
          this.renderBody()
        }
      </div>
    )
  }
}
